<template>
  <section id="dash-profit" class="flex column">
    <!-- filters -->
    <div class="flex-1 w100">
      <div class="flex row middle">
        
        <div class="flex-2 w100">
          <div class="flex end filters-group-holder row">
            
            <div style="margin-right: 8px;" class="flex column no-mobile">
              <label>Editar</label>
              <div class="flex end w100" style="margin-top:12px">
              <router-link v-if="checkResource('profit')" :to="{ name: 'DashEdit', params: {dash_id: dash.id } }">
                  <div class="button secondary">
                    <i class="fas fa-edit"></i>
                  </div>
              </router-link>
              
              </div>
            </div>
            <div style="margin-right: 16px;" class="flex column no-mobile">
              <label>Atualizar</label>
              <div class="flex end w100" style="margin-top:12px">
                <div @click="forceRefreshData()" class="button secondary">
                  <i class="fas fa-sync-alt"></i>
                </div>
              </div>
            </div>

            <div style="margin-right: 16px;" class="flex column no-mobile">
              <label>TV</label>
              <div class="flex end w100" style="margin-top:12px">
                <div @click="fullScreenDash('dash-profit')" class="button secondary">
                  <i class="fas fa-tv"></i>
                </div>
              </div>
            </div>

            <div class="filter-item w100">
              <label>Produto</label>
              <select class="input" v-model="filters.data.product">
                <option v-for="(c, index) in filters.list.listProduct" :key="index" :value="c.value" :selected="c.value === filters.data.product">
                  {{ c.label }}
                </option>
              </select>
            </div>

            <ltk-date-picker
              label="Filtro de data"
              v-model="filters.data.date"
              :loading="loading"
            ></ltk-date-picker>
          </div>
        </div>
      </div>

    </div>

    <!-- big card -->
    <div class="flex-1 w100 margin-top-l">
      <div class="grid-flex wrap">
        <div class="item flex-1">
          <box-info
            icon="fas fa-cart-plus"
            label="Vendas"
            tooltip="Receita total de pedidos efetuados no período (Pedidos Aprovados + Pedidos Pendentes + Pedidos Cancelados)."
            :value="stats.sales"
            :money="false"
            :currency="filters.data.currency"
          >
          </box-info>
        </div>

        <div class="item flex-1">
          <box-info
            icon="fas fa-dollar-sign"
            label="Valor (BRL)"
            tooltip="Receita total de pedidos efetuados no período (Pedidos Aprovados + Pedidos Pendentes + Pedidos Cancelados)."
            :value="stats.receita_bruta"
            :money="true"
            :currency="filters.data.currency"
          >
          </box-info>
        </div>
        <div class="item flex-1">
          <box-info
            icon="fas fa-cart-plus"
            label="Vendas (USD)"
            tooltip="Receita total de pedidos efetuados no período (Pedidos Aprovados + Pedidos Pendentes + Pedidos Cancelados)."
            :value="stats.total_dollar"
            :money="false"
            :currency="filters.data.currency"
          >
          </box-info>
        </div>

        <div class="item flex-1">
          <box-info
            icon="fas fa-dollar-sign"
            label="Valor (USD)"
            tooltip="Receita total de pedidos efetuados no período (Pedidos Aprovados + Pedidos Pendentes + Pedidos Cancelados)."
            :value="stats.sum_dollar"
            :money="true"
            currency="USD"
          >
          </box-info>
        </div>
      </div>
    </div>
    <!-- big card -->
    <div class="flex-1 w100 margin-top-l">
      <div class="grid-flex wrap">
        <div class="item flex-1">
          <box-info
            icon="fas fa-th-large"
            label="Visitas"
            tooltip="Receita total de pedidos efetuados no período (Pedidos Aprovados + Pedidos Pendentes + Pedidos Cancelados)."
            :value="stats.pageview"
            :money="false"
            :currency="filters.data.currency"
            suffix=""
          >
          </box-info>
        </div>
        <div class="item flex-1">
          <box-info
            icon="fas fa-th-large"
            label="Conversão"
            tooltip="Receita total de pedidos efetuados no período (Pedidos Aprovados + Pedidos Pendentes + Pedidos Cancelados)."
            :value="stats.conv"
            :money="false"
            :currency="filters.data.currency"
            suffix="%"
          >
          </box-info>
        </div>

        <div class="item flex-1">
          <box-info
            icon="fas fa-users"
            label="Compradores"
            tooltip="Receita total de pedidos efetuados no período (Pedidos Aprovados + Pedidos Pendentes + Pedidos Cancelados)."
            :value="stats.customers"
            :money="false"
            :currency="filters.data.currency"
          >
          </box-info>
        </div>

      </div>
    </div>
    <!-- cards -->
    <div class="flex-1 margin-top-s w100">
      <div class="grid-flex wrap">
        
        <div class="item flex-1">
          <box-info
            icon="fas fa-dollar-sign"
            label="Cotação USD"
            tooltip="Cotação de USD para BRL útilizada na conversão"
            :value="stats.quotation_usd_to_brl"
            :money="true"
            :currency="filters.data.currency"
          >
          </box-info>
        </div>

        <div class="item flex-1">
          <box-info
            icon="fas fa-bullhorn"
            label="Custo de Marketing"
            tooltip="Somatório de custos de campanhas ATIVAS"
            :value="stats.cost_marketing"
            :money="true"
            :currency="filters.data.currency"
          >
          </box-info>
        </div>

        <div class="item flex-1">
          <box-info
            icon="fas fa-dollar-sign"
            label="Ticket Médio"
            tooltip="Receita Líquida / Número de pedidos APROVADOS"
            :value="stats.avg_ticket"
            :money="true"
            :currency="filters.data.currency"
          >
          </box-info>
        </div>

        <div class="item flex-1">
          <box-info
            icon="fas fa-bullhorn"
            label="CPA"
            tooltip="Custo de Aquisição (Custo de Marketing / Número de pedidos aprovados)"
            :value="stats.cpa"
            :money="true"
            :currency="filters.data.currency"
          >
          </box-info>
        </div>

        <div class="item flex-1">
          <box-info
            icon="fas fa-dollar-sign"
            :label="
              `Pedidos Aprovados (${$filters.number(
                stats.approved_sales_count
              )})`
            "
            tooltip="Receita de pedidos aprovados"
            :value="stats.approved_sales_sum"
            :money="true"
            :currency="filters.data.currency"
          >
          </box-info>
        </div>

        <div class="item flex-1">
          <box-info
            icon="fas fa-dollar-sign"
            :label="
              `Pedidos Pendentes (${$filters.number(
                stats.await_payment_sales_count
              )})`
            "
            tooltip="Receita de pedidos pendentes"
            :value="stats.await_payment_sales_sum"
            :money="true"
            :currency="filters.data.currency"
          >
          </box-info>
        </div>

      </div>

      <!-- cards -->
      <div class="flex-1 margin-top-l w100">
        <div class="grid-flex wrap">
          <div class="item flex-1">
            <box-info
              icon="fab fa-facebook"
              bigIcon="True"
              label="Custo de Marketing FBADS"
              tooltip="Somatório de custos de campanhas ATIVAS FACEBOOK ADS"
              :value="stats.fbads_cost_marketing"
              :money="true"
              :currency="filters.data.currency"
            >
            </box-info>
          </div>

          <div class="item flex-1">
            <box-info
              icon="fab fa-google"
              bigIcon="True"
              label="Custo de Marketing GADS"
              tooltip="Somatório de custos de campanhas ATIVAS GOOGLE ADS"
              :value="stats.gads_cost_marketing"
              :money="true"
              :currency="filters.data.currency"
            >
            </box-info>
          </div>

          <div class="item flex-1">
            <box-info
              icon="fas fa-balance-scale"
              label="ROAS"
              tooltip="Retorno Sobre o Investimento em Marketing (Receita Líquida) / (Somátorio de Marketing)"
              :value="stats.roas"
              suffix="x"
            >
            </box-info>
          </div>

          <div class="grid-flex wrap w100">
            <div class="item flex-1 center-txt">
              <div class="box2  ">
                <div class="box-content2">
                  <div class="flex row">
                    <custom-line
                      class="margin-top-m w100"
                      :data="chartDataPolarMKT.data"
                      :colors="colorsMKT"
                    ></custom-line>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="flex-1 w100 margin-top-l  no-mobile">
        <div class="flex">
          <tabs :data="originTabs" v-model="currentTabOrigin"></tabs>
        </div>
      </div>
      <!-- group by sale -->
      <div class="box flex-1 w100 margin-top-l  no-mobile">
        <div class="flex box-title middle">
          <div class="flex-1">
            <h4>
              Explorador de Origens
            </h4>
          </div>
          <div class="flex end filters-group-holder">
            <div class="filter-item">
              <label>Buscar</label>
              <div class="flex w100">
                <input class="input" type="text" v-model="filters.data.search" />
              </div>
            </div>
            <div class="filter-item">
              <label>Agrupar por</label>
              <select class="input" v-model="filters.data.group_by">
                <option
                  v-for="(c, index) in listOriginList"
                  :key="index"
                  :value="c.value"
                  :selected="c.value === filters.data.group_by"
                >
                  {{ c.label }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="box-content max-table">
          <ul>
            <li class="header">
              <div class="flex middle row">
                <div class="flex-1">
                  <div class="flex middle row">
                    <div class="flex-1 name">
                      <b>{{ filters.data.group_by }}</b>
                    </div>
                    <div class="flex-1">
                      <div class="flex details between">
                        <div class="flex-1 txt-center">
                          <p><b>Visitas</b></p>
                        </div>
                        <div class="flex-1 txt-center">
                          <p><b>Vendas</b></p>
                        </div>
                        <div class="flex-1 txt-center">
                          <p><b>Conversão</b></p>
                        </div>
                        <div class="flex-1 txt-center">
                          <p><b>CPA</b></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li v-for="(track, index) in trackings" :key="index">
              <div class="flex middle row">
                <div class="flex-3">
                  <div class="flex middle row">
                    <div class="flex-1 name margin-top-s">
                      <p>
                        {{ track.name | protect }}
                      </p>
                    </div>
                    <div class="flex-1 margin-top-s">
                      <div class="flex details between">
                        <div class="flex-1 txt-center">
                          {{ track.stats.pageview | number }}
                        </div>
                        <div class="flex-1 txt-center">
                          {{ track.stats.sales | number }}
                        </div>
                        <div class="flex-1 txt-center">
                          {{ track.stats.conv }}%
                        </div>
                        <div v-if="filters.data.group_by == 'campaign'" class="flex-1 txt-center">
                          {{ track.stats.cpa | money }}
                        </div>
                        <div v-else class="flex-1 txt-center"> - </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>

          <div v-if="isEmpty" class="center-text">
            <div class="margin-top-l">
              <p>
                Não encontramos nenhuma origem de venda. Assim que você tiver a
                primeira venda a origem vai aparecer nessa lista de forma
                automática!
              </p>
            </div>
          </div>

          <div v-if="loading">
            <content-loading>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
            </content-loading>
          </div>

          <!-- pagination -->
          <div class="flex-1 flex row w100 middle margin-top-l">
            <div class="flex w100 center filters-groupo-holder">
              <div class="flex between middle">
                <paginate
                  :containerClass="'pagination'"
                  :page-count="totalPages"
                  v-model="page"
                  :page-range="5"
                  :click-handler="clickCallback"
                  :prev-text="'Anterior'"
                  :next-text="'Próxima'"
                ></paginate>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="flex-1 margin-top-l no-mobile">
        <div class="">
          <h3>Detalhamento por Produtos</h3>
        </div>
      </div>
      <div class="flex-1 margin-top-l w100  no-mobile">
      <div class="item flex-1 w100">
        <div class="flex-1">
        <div class="box">
          <div class="box-content max-table">
            <ul>
              <li class="header">
                <div class="flex middle row">
                  <div class="flex-1">
                    <div class="flex middle row">
                      <div class="flex-1">
                        <div class="flex details between">
                          <div class="flex-1">
                            <p><b>Produto</b></p>
                          </div>
                          <div class="flex-1 txt-center">
                            <p><b>Percentual das Vendas</b></p>
                          </div>
                          <div class="flex-1 txt-center">
                            <p><b>Vendas</b></p>
                          </div>
                          <div class="flex-1 txt-center">
                            <p><b>Vendas Aprovadas</b></p>
                          </div>
                          <div class="flex-1 txt-center">
                            <p><b>Receita Bruta</b></p>
                          </div>
                          <div class="flex-1 txt-center">
                            <p><b>Receita Líquida</b></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li v-for="(p, index) in products" :key="index">
                <div class="flex middle row">
                  <div class="flex-3">
                    <div class="flex middle row">
                      <div class="flex-1 margin-top-s">
                        <div class="flex details between">
                          <div class="flex-1">
                            {{ p.name | protect }}
                          </div>
                          <div class="flex-1 txt-center">
                            <b v-if="p.percent > 0">{{ p.percent | number }}%</b>
                            <b v-else> - </b>
                          </div>
                          <div class="flex-1 txt-center">
                            <b v-if="p.qtn > 0">{{ p.qtn | number }}</b>
                            <b v-else> - </b>
                          </div>
                          <div class="flex-1 txt-center">
                            <b v-if="p.qtn_approved > 0">{{ p.qtn_approved | number }}</b>
                            <b v-else> - </b>
                          </div>
                          <div class="flex-1 txt-center">
                            {{ p.value | money }}
                          </div>
                          <div class="flex-1 txt-center">
                            {{ p.value_approved | money }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li class="margin-top-m">
                <div class="flex middle row">
                  <div class="flex-3">
                    <div class="flex middle row">
                      <div class="flex-1 margin-top-s">
                        <div class="flex details between">
                          <div class="flex-1">
                            <b>Total</b>
                          </div>
                          <div class="flex-1 txt-center">
                            <b>-</b>
                          </div>
                          <div class="flex-1 txt-center">
                            <b>{{ sum(auxTableHours, 'sales') | number }}</b>
                          </div>
                          <div class="flex-1 txt-center">
                            <b>{{ sum(auxTableHours, 'approved_sales') | number }}</b>
                          </div>
                          <div class="flex-1 txt-center">
                            <b>{{ sum(auxTableHours, 'receita_bruta') | money }}</b>
                          </div>
                          <div class="flex-1 txt-center">
                            <b>{{ sum(auxTableHours, 'aproved_sales') | money }}</b>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>

          </div>
        </div>
      </div>

      </div>
    </div>

      <div class="flex-1 margin-top-l no-mobile">
        <div class="">
          <h3>Detalhamento por Dia</h3>
        </div>
      </div>

      <div class="flex-1 w100 margin-top-l  no-mobile">
        <div class="flex">
          <tabs :data="reportTabs" v-model="currentTab"></tabs>
        </div>
      </div>
      <div v-if="currentTab === 'table'" class="flex-1 no-mobile">
        <div class="box margin-top-l">
          <div class="box-content max-table">
            <ul>
              <li class="header">
                <div class="flex middle row">
                  <div class="flex-1">
                    <div class="flex middle row">
                      <div class="flex-1">
                        <div class="flex details between">
                          <div class="flex-1 txt-center">
                            <p><b>Data</b></p>
                          </div>
                          <div class="flex-1 txt-center">
                            <p><b>Vendas</b></p>
                          </div>
                          <div class="flex-1 txt-center">
                            <p><b>Vendas Aprovadas</b></p>
                          </div>
                          <div class="flex-1 txt-center">
                            <p><b>Lucro</b></p>
                          </div>
                          <div class="flex-1 txt-center">
                            <p><b>Tax. Lucro</b></p>
                          </div>
                          <div class="flex-1 txt-center">
                            <p><b>CPA</b></p>
                          </div>
                          <div class="flex-1 txt-center">
                            <p><b>Marketing</b></p>
                          </div>
                          <div class="flex-1 txt-center">
                            <p><b>Receita Líquida</b></p>
                          </div>
                          <div class="flex-1 txt-center">
                            <p><b>Receita Bruta</b></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li v-for="(t, index) in auxTable" :key="index">
                <div class="flex middle row">
                  <div class="flex-3">
                    <div class="flex middle row">
                      <div class="flex-1 margin-top-s">
                        <div class="flex details between">
                          <div class="flex-1 txt-center">
                            {{ t.date }}
                          </div>
                          <div class="flex-1 txt-center">
                            <b>{{ t.stats.sales | number }}</b>
                          </div>
                          <div class="flex-1 txt-center">
                            <b>{{ t.stats.approved_sales | number }}</b>
                          </div>
                          <div class="flex-1 txt-center" :class="{ red: t.stats.profit < 0, gren: t.stats.profit > 0}">
                            <b>{{ t.stats.profit | money }}</b>
                          </div>
                          <div class="flex-1 txt-center" :class="{ red: t.stats.tax_profit < 10, gren: t.stats.tax_profit > 10}">
                            <b>{{ t.stats.tax_profit | number }}%</b>
                          </div>
                          <div class="flex-1 txt-center">
                            <b>{{ t.stats.cpa | money }}</b>
                          </div>
                          <div class="flex-1 txt-center">
                            {{ t.stats.marketing | money }}
                          </div>
                          <div class="flex-1 txt-center">
                            {{ t.stats.receita_bruta | money }}
                          </div>
                          <div class="flex-1 txt-center">
                            {{ t.stats.aproved_sales | money }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>

              <li class="margin-top-m">
                <div class="flex middle row">
                  <div class="flex-3">
                    <div class="flex middle row">
                      <div class="flex-1 margin-top-s">
                        <div class="flex details between">
                          <div class="flex-1 txt-center">
                            <b>Total</b>
                          </div>
                          <div class="flex-1 txt-center">
                            <b>{{ sum(auxTable, 'sales') | number }}</b>
                          </div>
                          <div class="flex-1 txt-center">
                            <b>{{ sum(auxTable, 'approved_sales') | number }}</b>
                          </div>
                          <div class="flex-1 txt-center">
                            <b>{{ sum(auxTable, 'profit') | money }}</b>
                          </div>
                          <div class="flex-1 txt-center">
                            <b>{{ avg(auxTable, 'tax_profit') | number }}%</b>
                          </div>
                          <div class="flex-1 txt-center">
                            <b>{{ avg(auxTable, 'cpa') | money }}</b>
                          </div>
                          <div class="flex-1 txt-center">
                            <b>{{ sum(auxTable, 'marketing') | money }}</b>
                          </div>
                          <div class="flex-1 txt-center">
                            <b>{{ sum(auxTable, 'receita_bruta') | money }}</b>
                          </div>
                          <div class="flex-1 txt-center">
                            <b>{{ sum(auxTable, 'aproved_sales') | money }}</b>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>

          </div>
        </div>
      </div>
      <!-- graph days -->
      <div v-if="currentTab === 'graph'" class="flex-1 no-mobile">
        <div class="box margin-top-l">
          <div class="box-content">
            <bar-chart
              v-if="
                chartDataLine.data.datasets &&
                  chartDataLine.data.datasets.length > 0
              "
              class="margin-top-l"
              :height="140"
              :chartData="chartDataLine.data"
              :options="chartDataLine.options"
              :limit="30"
              color="green"
            ></bar-chart>
          </div>
        </div>
      </div>


    <div class="flex-1 margin-top-l no-mobile">
        <div class="">
          <h3>Detalhamento por Hora</h3>
        </div>
      </div>

      <div class="flex-1 w100 margin-top-l  no-mobile">
        <div class="flex">
          <tabs :data="reportTabs" v-model="currentTabHours"></tabs>
        </div>
      </div>
      <div v-if="currentTabHours === 'table'" class="flex-1 no-mobile">
        <div class="box margin-top-l">
          <div class="box-content max-table">
            <ul>
              <li class="header">
                <div class="flex middle row">
                  <div class="flex-1">
                    <div class="flex middle row">
                      <div class="flex-1">
                        <div class="flex details between">
                          <div class="flex-1 txt-center">
                            <p><b>Hora</b></p>
                          </div>
                          <div class="flex-1 txt-center">
                            <p><b>Vendas</b></p>
                          </div>
                          <div class="flex-1 txt-center">
                            <p><b>Vendas Aprovadas</b></p>
                          </div>
                          <div class="flex-1 txt-center">
                            <p><b>Receita Bruta</b></p>
                          </div>
                          <div class="flex-1 txt-center">
                            <p><b>Receita Líquida</b></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li v-for="(t, index) in auxTableHours" :key="index">
                <div class="flex middle row">
                  <div class="flex-3">
                    <div class="flex middle row">
                      <div class="flex-1 margin-top-s">
                        <div class="flex details between">
                          <div class="flex-1 txt-center">
                            {{ t.date }}
                          </div>
                          <div class="flex-1 txt-center">
                            <b v-if="t.stats.sales > 0">{{ t.stats.sales | number }}</b>
                            <b v-else> - </b>
                          </div>
                          <div class="flex-1 txt-center">
                            <b v-if="t.stats.approved_sales > 0">{{ t.stats.approved_sales | number }}</b>
                            <b v-else> - </b>
                          </div>
                          <div class="flex-1 txt-center">
                            {{ t.stats.receita_bruta | money }}
                          </div>
                          <div class="flex-1 txt-center">
                            {{ t.stats.aproved_sales | money }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li class="margin-top-m">
                <div class="flex middle row">
                  <div class="flex-3">
                    <div class="flex middle row">
                      <div class="flex-1 margin-top-s">
                        <div class="flex details between">
                          <div class="flex-1 txt-center">
                            <b>Total</b>
                          </div>
                          <div class="flex-1 txt-center">
                            <b>{{ sum(auxTableHours, 'sales') | number }}</b>
                          </div>
                          <div class="flex-1 txt-center">
                            <b>{{ sum(auxTableHours, 'approved_sales') | number }}</b>
                          </div>
                          <div class="flex-1 txt-center">
                            <b>{{ sum(auxTableHours, 'receita_bruta') | money }}</b>
                          </div>
                          <div class="flex-1 txt-center">
                            <b>{{ sum(auxTableHours, 'aproved_sales') | money }}</b>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>

          </div>
        </div>
      </div>
      <!-- graph days -->
      <div v-if="currentTabHours === 'graph'" class="flex-1 no-mobile">
        <div class="box margin-top-l">
          <div class="box-content">
            <bar-chart
              v-if="
                chartDataHour.data.datasets &&
                  chartDataHour.data.datasets.length > 0
              "
              class="margin-top-l"
              :height="140"
              :chartData="chartDataHour.data"
              :options="chartDataHour.options"
              :limit="30"
              color="green"
            ></bar-chart>
          </div>
        </div>
      </div>

    </div>

  </section>
</template>

<script>
import { getProfit } from "@/services/profit";
import { getFilters } from "@/services/filters";
import { getTrackings } from "@/services/tracking.js";


import barChart from "@/components/charts/barChart";
import boxInfo from "@/components/boxInfo/BoxInfo";
import ltkDatePicker from "@/components/datepicker/LtkDatePicker";
import customLine from "./customLine";

import Tabs from "@/components/tabs/Tabs";


import moment from "moment";
moment.locale("pt-br");

import { mapState } from "vuex";

const emptyData = {
  profit: "-",
  sales: "-",
  receita_bruta: "-",
  receita_liquida: "-",
  cost_product: "-",
  gads_cost_marketing: "-",
  fbads_cost_marketing: "-",
  cost_marketing: "-",
  cost_tax: "-",
  cost_impost: "-",
  conv_billet: "-",
  avg_ticket: "-",
  percent_profit: "-",
  cpa: "-",
  fbads_cpa: "-",
  gads_cpa: "-",
  roi: "-",
  approved_sales_count: "-",
  approved_sales_sum: "-",
  await_payment_sales_count: "-",
  await_payment_sales_sum: "-",
  sum_commission_dollar: "-",
  sum_dollar: "-",
};

export default {
  name: "sale",
  components: {
    barChart,
    customLine,
    ltkDatePicker,
    boxInfo,
    Tabs,
  },
  props: ["dash"],
  data() {
    return {
      loading: false,
      isTvMode: false,
      stats: emptyData,
      refreshTime: 60, // 60s refresh data
      refreshInterval: null,
      currentTabOrigin: "campaign",
      currentTab: "table",
      currentTabHours: "table",
      UTMS: {
        utm_campaign: [],
        utm_medium: [],
        utm_source: [],
        utm_content: [],
        utm_term: [],
        src: [],
        sck: [],
      },
      offset: 10,
      page: 1,
      totalTracking: 0,
      trackings: [],
      originTabs: [
        {
          name: "campaign",
          title: "Campanha / Conjunto / Ad",
        },
        {
          name: "utm",
          title: "UTMS",
        },
      ],
      reportTabs: [
        {
          name: "table",
          title: "Tabela",
        },
        {
          name: "graph",
          title: "Gráfico",
        },
      ],
      filters: {
        data: {
          date: [
            moment()
              .add(-0, "d")
              .startOf("day")
              .toDate(),
            moment()
              .startOf("day")
              .toDate(),
          ],
          currency: 'BRL',
          sumCostsFixed: true,
          product: '',
          accountAds: '',
          group_by: "campaign",
          search: "",
        },
        list: {
          listCurrency: [
            {
              value: 'BRL',
              label: 'Real Brasileiro (BRL)'
            },
            {
              value: 'USD',
              label: 'Dólar Americano (USD)'
            }
          ],
          listAccountAds: [],
          listProduct: [],
        },
      },
      chartDataLine: {
        options: {},
        data: {
          labels: [],
          datasets: [],
        },
      },
      chartDataHour: {
        options: {},
        data: {
          labels: [],
          datasets: [],
        },
      },
      chartDataPolar: {
        data: {
          Cartão: "-",
          Pix: "-",
          Boleto: "-",
        },
      },
      chartDataPolarConversion: {
        data: {
          Cartão: "-",
          Pix: "-",
          Boleto: "-",
        },
      },
      chartDataPolarMKT: {
        data: {
          FacebookAds: "-",
          GoogleAds: "-",
        },
      },
      colorsMKT: [
        '#3B5998',
        '#DB4437'
      ],
      funnelData: {
        labels: [
          // "Impressions",
          "Page View",
          "Add To Cart",
          "Initiate checkout",
          "Add Payment info",
          "Purchase",
        ],
        subLabels: [],
        values: [],
        colors: ["#b12031", "#2B2D42"], // color set for "Add To Cart" segment
        direction: "horizontal",
        gradientDirection: "horizontal",
        height: 300,
        width: 1024,
      },
      products: [],
    };
  },
  mounted() {
    
    if (this.dash) {
      this.initFilters()
    } else {
      this.getReport()
      this.getFilters()
    }


    this.refreshInterval = setInterval(this.getReport, this.refreshTime * 1000)
  },
  beforeDestroy() {
    clearInterval(this.refreshInterval)
  },
  
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
    totalPages() {
      let valueMode = this.totalTracking % this.offset;
      let value = this.totalTracking / this.offset;

      let pages = 1;

      if (valueMode == 0) {
        pages = value;
      } else {
        pages = parseInt(value) + 1;
      }

      return pages;
    },
    listOriginList() {
      if (this.currentTabOrigin === "campaign") {
          return [
          {
              value: "campaign",
              label: "Campanhas",
            },
            {
              value: "adgroup",
              label: "Conjunto de Anúncios",
            },
            {
              value: "ad",
              label: "Anúncios",
            },
          ]
        }
      return [
              {
                value: "utm_campaign",
                label: "utm_campaign",
              },
              {
                value: "utm_source",
                label: "utm_source",
              },
              {
                value: "utm_medium",
                label: "utm_medium",
              },
              {
                value: "utm_content",
                label: "utm_content",
              },
              {
                value: "utm_term",
                label: "utm_term",
              },
              {
                value: "sck",
                label: "sck",
              },
              {
                value: "src",
                label: "src",
              },
        ]
      
    },

    auxTable() {
      if (!this.chartDataLine.data.datasets && this.chartDataLine.data.datasets.length === 0) {
        return []
      }

      var newTable = []
      this.chartDataLine.data.labels.forEach((e, i) =>  {

        newTable.push({
          date: e,
          stats: {
            profit: this.chartDataLine.data.datasets[0].data[i],
            marketing: this.chartDataLine.data.datasets[1].data[i],
            receita_bruta: this.chartDataLine.data.datasets[2].data[i],
            aproved_sales: this.chartDataLine.data.datasets[3].data[i],
            sales: this.chartDataLine.data.datasets[4].data[i],
            approved_sales: this.chartDataLine.data.datasets[5].data[i],
            cpa: this.chartDataLine.data.datasets[6].data[i],
            tax_profit: this.chartDataLine.data.datasets[7].data[i],
          }
        })
      })

      return newTable.reverse()
    },
    auxTableHours() {
      if (!this.chartDataHour.data.datasets && this.chartDataHour.data.datasets.length === 0) {
        return []
      }

      var newTable = []
      this.chartDataHour.data.labels.forEach((e, i) =>  {

        newTable.push({
          date: e,
          stats: {
            receita_bruta: this.chartDataHour.data.datasets[0].data[i],
            aproved_sales: this.chartDataHour.data.datasets[1].data[i],
            sales: this.chartDataHour.data.datasets[2].data[i],
            approved_sales: this.chartDataHour.data.datasets[3].data[i],
          }
        })
      })

      return newTable
    },
    isEmptyFunnel() {
      if (!this.funnelData.values || this.funnelData && !this.funnelData.values) {
        return true
      }
      const soma = this.funnelData.values.reduce((acumulador, arrayAtual) => {
        return acumulador + arrayAtual[0];
      }, 0);

      return soma <= 0
    }
  },
  watch: {
    "filters.data": {
      deep: true,
      handler() {
        this.stats = emptyData;
        this.getReport();
        this.getFilters();
      },
    },
    "currentTabOrigin": {
      handler() {
        if (this.currentTabOrigin === 'campaign') {
          this.filters.data.group_by = 'campaign'
        } else {
          this.filters.data.group_by = 'utm_campaign'
        }
      }
    },
    page: {
      handler() {
        this.trackings = [];
        this.getTrackings();
      },
    },
  },
  methods: {
    initFilters() {
      let product = this.dash.custom_filters.product || ''
      let mktaccount = this.dash.custom_filters.mkt_account || ''
      let date = this.dash.custom_filters.date

      var _copyFilterData = Object.assign({}, this.filters.data)

      _copyFilterData.product = product 
      _copyFilterData.accountAds = mktaccount

      var _map_date = {
        'DAY': 0,
        'LAST7': -7,
        'LAST14': -14,
        'LAST30': -30,
        'LAST90': -90,
        'LASTMAX': -365,
      }

      var _code_day = _map_date[date] || 0
      var _init_day = 0 
      if (_code_day < 0) {
        _init_day = -1
        _code_day -= 1
      }
      let dateNew = [
            moment()
              .add(_code_day, "d")
              .startOf("day")
              .toDate(),
            moment()
              .add(_init_day, "d")
              .startOf("day")
              .toDate(),
      ]

      _copyFilterData.date = dateNew

      this.filters.data = _copyFilterData
      
    },
    getFilters() {
      const date = this.filters.data.date;
      let params = {
        start_date: date[0] ? date[0].toISOString().slice(0, 10) : "",
        end_date: date[1] ? date[1].toISOString().slice(0, 10) : "",
      }
      getFilters(params)
        .then((result) => {
            this.filters.list.listAccountAds = result.accountAds
            this.filters.list.listProduct = result.products.filter(p => p.qtn > 0)
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu um problema'
          })
        })
    },
    sum(array, param) {
      if (param === undefined) {
        return array.reduce((total, e) => total + e, 0);
      }
      return array.reduce((total, e) => total + e.stats[param], 0);
    },
    avg(array, param) {
      return this.sum(array, param) / array.length;
    },
    forceRefreshData() {
      this.stats = emptyData;
      this.getReport();
    },
    fullScreenDash(elementId) {
      var elem = document.getElementById(elementId);

      // disable fullscreen
      if (this.isTvMode) {
        this.isTvMode = false;
        document.exitFullscreen();
        document.body.style.zoom=1;

        return;
      }

      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        /* Firefox */
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        /* Chrome, Safari & Opera */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        /* IE/Edge */
        elem.msRequestFullscreen();
      }

      document.body.style.zoom=0.8;

      this.isTvMode = true;
    },
    checkResource(name) {
      return this.account && this.account.resources.includes(name);
    },
    getReport() {
      if (this.loading) {
        return
      }

      this.getTrackings()

      this.loading = true;

      const date = this.filters.data.date;
      let params = {
        start_date: date[0] ? date[0].toISOString().slice(0, 10) : "",
        end_date: date[1] ? date[1].toISOString().slice(0, 10) : "",
        currency: this.filters.data.currency,
        product_id: this.filters.data.product,
        account_ads: this.filters.data.accountAds,
        sum_costs_fixed: this.filters.data.sumCostsFixed,
        is_dash_profit: true,
      };

      getProfit(params)
        .then((result) => {
          this.stats = result.stats;

          this.chartDataPolar = result.bar_line;
          this.chartDataPolarMKT = result.bar_line_mkt;
          this.chartDataPolarConversion = result.conversion_line

          this.products = result.products;

          // format graph
          this.chartDataLine.data.labels = result.graph_day.labels;
          
          let auxDataset = [];

          result.graph_day.data.forEach((d) => {
            auxDataset.push({
              label: d.label,
              data: d.data,
            });
          });

          this.chartDataLine.data.datasets = auxDataset;

          // format graph
          this.chartDataHour.data.labels = result.graph_hour.labels;
          
          let auxDataSetHour = [];

          result.graph_hour.data.forEach((d) => {
            auxDataSetHour.push({
              label: d.label,
              data: d.data,
            });
          });

          this.chartDataHour.data.datasets = auxDataSetHour;

          this.funnelData.subLabels = result.funnel_marketing.sublabels;
          this.funnelData.labels = result.funnel_marketing.labels;
          this.funnelData.values = result.funnel_marketing.values;
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }

          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao buscar dados",
          });
        })
        .finally(() => {
          this.loading = false;
          this.data = emptyData;
        });
    },
    getTrackings() {
      this.loading = true;

      const date = this.filters.data.date;
      let params = {
        start_date: date[0] ? date[0].toISOString().slice(0, 10) : "",
        end_date: date[1] ? date[1].toISOString().slice(0, 10) : "",
        group_by: this.filters.data.group_by,
        search: this.filters.data.search,
        page: this.page,
        offset: this.offset,
      };
      getTrackings(params)
        .then((result) => {
          this.trackings = result.trackings.map((p) => {
            return {
              name: p.name,
              group_by: p.group_by,
              stats: {
                sales: p.stats.sales,
                approved_sales_sum: p.stats.approved_sales_sum,
                receita_bruta: p.stats.receita_bruta,
                sales_all: p.stats.sales_all,
                pageview: p.stats.pageview,
                value: p.stats.value,
                conv: p.stats.conv,
                spend: p.stats.spend,
                cpa: p.stats.cpa,
              },
            };
          });

          // utms
          this.UTMS = result.utms;

          this.totalTracking = result.total;

          // this.stats = result.stats;
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao buscar tracking",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>

#dash-profit {
  background: var(--bg)
}

.filters-group-holder {
  position: sticky;
  top: -1px;
  z-index: 4;

  &[stuck] {
    background: var(--bg);
    padding: 35px 5px 15px 5px;
  }
}

.custom-card {
  min-width: 250px;
  padding: 8px !important;
  position: relative;
  .big-icon {
    i {
      color: var(--primary);
      font-size: 28px;
    }
  }
  .title {
    white-space: nowrap;
  }
  .info {
    position: absolute;
    right: 4px;
    top: 4px;
    font-size: 16px;
  }
  h3 {
    font-size: 22px;
    white-space: nowrap;
  }
  h1 {
    font-size: 32px;
    color: var(--primary);
  }

  &.negative {
    h1 {
      //color: #ff2727b5 !important;
      color: #fff !important;
    }
  }
}
.primary-bg {
  background: var(--primary);

  h1 {
    color: #fff;
  }

  span {
    color: #fff;
  }
}

li {
  list-style-type: none;
  padding-bottom: 8px;
  padding-top: 8px;
  border-bottom: 1px solid #e6e4e4;
  padding-left: 8px;
  
}

.red {
    // color: red;
    color: #000;
  }
.gren {
    color: #000;
    // color: green;
}

.max-table {
  overflow-y: scroll;
  max-height: 400px;
  padding-bottom: 16px;
}

</style>
